import getComponentInstanceFor from '@swey/vue-hydration/getComponentInstanceFor';
import Modal from '@components/013-Modal/Modal.client';
import IAnnouncementLayerOptions from '@frontend/types/modules/IAnnouncementLayerOptions';

export default class AnnouncementLayer {
	private readonly element: HTMLElement;

	public static constants = {
		LOCAL_STORAGE_NAME: 'announcementLayerHistory',
		DAYS_UNTIL_EXPIRATION: 1
	};

	public static domSelectors = {
		announcementModal: '.m-announcement-layer__modal',
		announcementContent: '.m-announcement-layer__modal-content'
	};

	private options: IAnnouncementLayerOptions = { delay: 2000, announcementId: '', showAlways: false };

	private id!: string;

	private history!: Record<string, number>;

	public constructor(element: HTMLElement) {
		this.element = element;
		this.init();
	}

	private init(): void {
		const optionsString = this.element.getAttribute('data-options');
		const options = optionsString ? JSON.parse(optionsString) : {};

		this.options = { ...this.options, ...options };
		this.id = `id-${this.options.announcementId}`;

		const historyString = localStorage ? localStorage.getItem(AnnouncementLayer.constants.LOCAL_STORAGE_NAME) : null;
		this.history = historyString ? JSON.parse(historyString) : {};

		this.checkAnnouncementLayerHistory();
	}

	protected checkAnnouncementLayerHistory(): void {
		if (this.options.showAlways || !localStorage) {
			this.openModal();
			return;
		}

		const expirationMilliseconds: number = AnnouncementLayer.constants.DAYS_UNTIL_EXPIRATION * 24 * 60 * 60 * 1000;
		const lastTimeSeen: number = this.history[this.id] || 0;
		const now: number = new Date().getTime();

		if (!lastTimeSeen || now >= lastTimeSeen + expirationMilliseconds) {
			this.openModal();
		}
	}

	private saveAsSeen(): void {
		this.history[this.id] = new Date().getTime();

		try {
			localStorage.setItem(AnnouncementLayer.constants.LOCAL_STORAGE_NAME, JSON.stringify(this.history));
		} catch (error) {
			// Local storage not available
		}
	}

	private openModal(): void {
		const modalElement: HTMLElement | null = this.element.querySelector(
			AnnouncementLayer.domSelectors.announcementModal
		);

		if (!modalElement) {
			return;
		}

		if (!this.options.showAlways) {
			modalElement.addEventListener(Modal.events.MODAL_CLOSED, (): void => {
				this.saveAsSeen();
			});
		}

		setTimeout((): void => {
			const modalComponent: Modal = getComponentInstanceFor(modalElement) as Modal;

			if (modalComponent) {
				modalComponent.openModal();
			}
		}, this.options.delay);
	}
}
